export function getCustomerPhone(customer) {
    return customer?.phoneNumber;
}

export function getCustomerEmail(customer) {
    return customer?.email;
}

export function getCustomerFullName(customer) {
    return ((customer?.firstName || "") + " " + (customer?.lastName || "")).trim();
}

export function getCustomerId(customer) {
    return customer?.id;
}

export function getCustomerBrand(customer) {
    return customer?.merchantBrand;
}

export function customerHasStatistics(customer) {
    return !!customer?.statistics;
}

export function customerHasAnyFlags(customer) {
    return !!(customer?.blacklisted || customer?.blockEarlyCompensation);
}
